/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * NOT_EQUAL operator looks for values that are not equal to the given value.
 */
export interface NotEqualKeyType {
    /** The value to compare against. */
    value: Truvity.NotEqualKeyTypeValue;
}
